import { z } from 'zod';
import type {
  CancelInboundReceiptRequest,
  CancelInboundReceiptResponse,
} from './cancel-inbound-receipt.dto.js';
import { InboundReceiptDetailDtoSchema } from './inbound-receipts-shared.schema.js';

export const CancelInboundReceiptRequestSchema: z.ZodType<CancelInboundReceiptRequest> = z
  .object({
    companyId: z.uuid(),
    receiptId: z.uuid(),
    stationId: z.uuid(),
    reason: z.string().trim().min(1),
  })
  .strict();

export const CancelInboundReceiptResponseSchema: z.ZodType<CancelInboundReceiptResponse> = z
  .object({
    receipt: InboundReceiptDetailDtoSchema,
  })
  .strict();
